(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-content"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    root.querySelectorAll('.cg-swipe-section').forEach(section => {
      if (section.dataset.cgReady) return;
      section.dataset.cgReady = 'true';
      const track = section.querySelector('.cg-content-items');
      const slides = [...track.children];
      const dots = [...section.querySelectorAll('[data-cg-dot]')];
      const prev = section.querySelector('[data-cg-prev]');
      const next = section.querySelector('[data-cg-next]');
      if (!prev || !next) return;
      let active = 0;
      const offset = i => slides[i].offsetLeft - slides[0].offsetLeft;
      const max = () => track.scrollWidth - track.clientWidth;
      const update = () => {
        const position = track.scrollLeft;
        section.querySelector('.cg-carousel-nav').hidden = max() < 2;
        dots.forEach((dot,i) => dot.hidden = i > 0 && Math.abs(Math.min(offset(i),max()) - Math.min(offset(i-1),max())) < 2);
        active = slides.reduce((best, _, i) => Math.abs(Math.min(offset(i),max()) - position) < Math.abs(Math.min(offset(best),max()) - position) ? i : best, 0);
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
        prev.disabled = position < 2;
        next.disabled = position >= max() - 2;
      };
      const go = i => track.scrollTo({left: Math.min(offset(Math.max(0, Math.min(slides.length - 1, i))), max()), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
      prev.addEventListener('click', () => go(active - 1));
      next.addEventListener('click', () => go(active + 1));
      track.addEventListener('scroll', () => {
        update();

      }, {passive:true});
      new ResizeObserver(update).observe(track);
      section.addEventListener('shopify:block:select', event => {
        const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) go(index);
      });
      update();
    });
  };
  const initVideos = root => {
    root.querySelectorAll('.cg-content--videos').forEach(section => {
      if(section.dataset.videoReady) return;
      section.dataset.videoReady = 'true';
      const videos = [...section.querySelectorAll('video')];
      const visible = new Set();
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const play = video => {
        if(document.hidden || reduced.matches) return;
        const result = video.play();
        if(result) result.catch(() => {});
      };
      videos.forEach(video => { video.muted = true; video.defaultMuted = true; });
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if(entry.isIntersecting && entry.intersectionRatio >= 0.5){
            visible.add(entry.target);
            play(entry.target);
          }else{
            visible.delete(entry.target);
            entry.target.pause();
          }
        });
      }, {threshold:[0,0.5]});
      videos.forEach(video => observer.observe(video));
      const visibility = () => videos.forEach(video => {
        if(document.hidden) video.pause();
        else if(visible.has(video)) play(video);
      });
      document.addEventListener('visibilitychange', visibility);
      const unload = event => {
        if(!event.target.contains(section)) return;
        observer.disconnect();
        videos.forEach(video => video.pause());
        document.removeEventListener('visibilitychange', visibility);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  init(document);
  initVideos(document);
  document.addEventListener('shopify:section:load', () => initVideos(document));
  document.addEventListener('shopify:section:load', () => init(document));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-product"] && !Shopify.designMode) return;
  try {
    
function initCollagenGallery(root) {
 root.querySelectorAll('.cg-product').forEach(section => {
  if(section.dataset.ready)return; section.dataset.ready='true';
  const track=section.querySelector('.cg-slides'), slides=[...track.children], thumbs=[...section.querySelectorAll('[data-slide]')], dots=[...section.querySelectorAll('[data-gallery-dot]')], prev=section.querySelector('[data-gallery-prev]'), next=section.querySelector('[data-gallery-next]');
  if(!slides.length)return;
  let index=0;
  const go=target=>{index=Math.max(0,Math.min(slides.length-1,target));track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
  const update=()=>{if(!track.clientWidth)return;index=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));dots.forEach((b,i)=>b.setAttribute('aria-current',String(i===index)));if(prev)prev.disabled=index===0;if(next)next.disabled=index===slides.length-1;};
  thumbs.forEach(b=>b.addEventListener('click',()=>go(Number(b.dataset.slide))));
  dots.forEach(b=>b.addEventListener('click',()=>go(Number(b.dataset.galleryDot))));
  if(prev)prev.addEventListener('click',()=>go(index-1));if(next)next.addEventListener('click',()=>go(index+1));
  track.addEventListener('scroll',update,{passive:true});
  track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1));}});
  new ResizeObserver(()=>{track.scrollTo({left:index*track.clientWidth,behavior:'instant'});update();}).observe(track);
  section.addEventListener('shopify:block:select',e=>{const i=slides.findIndex(slide=>slide===e.target||slide.contains(e.target));if(i>=0)go(i);});
  update();
 });
}
initCollagenGallery(document);
document.addEventListener('shopify:section:load',()=>initCollagenGallery(document));

function initCollagenOffers(root){
 root.querySelectorAll('.cg-bundle-form').forEach(form=>{
  if(form.dataset.offersReady)return;form.dataset.offersReady='true';
  const field=form.querySelector('.cg-offers'),radios=[...form.querySelectorAll('[name="cg_offer"]')],toggle=form.querySelector('[data-cg-subscription]'),box=form.querySelector('.cg-refill-box'),planInput=form.querySelector('[name="selling_plan"]'),button=form.querySelector('[type="submit"]'),note=form.querySelector('[data-purchase-note]');
  let wantsSubscription=field.dataset.defaultSubscription==='true'||field.dataset.requiredSubscription==='true';
  const required=field.dataset.requiredSubscription==='true';
  const available=radios.filter(r=>!r.disabled);
  const initial=available.find(r=>r.value===field.dataset.defaultOffer)||available[0];
  if(initial)initial.checked=true;
  const sync=()=>{
   const selected=radios.find(r=>r.checked&&!r.disabled);
   if(!selected){button.disabled=true;note.hidden=false;box.hidden=true;return;}
   const hasPlan=!!selected.dataset.plan;
   const subscribed=hasPlan&&(wantsSubscription||required);
   toggle.checked=subscribed;toggle.disabled=required;box.hidden=!hasPlan;
   form.querySelector('[data-plan-description]').textContent=selected.dataset.planName||'';
   form.querySelector('[name="id"]').value=selected.dataset.variant;
   form.querySelector('[name="quantity"]').value=selected.dataset.quantity;
   planInput.value=subscribed?selected.dataset.plan:'';
   planInput.disabled=!subscribed;
   button.disabled=required&&!hasPlan;note.hidden=!button.disabled;
   radios.forEach(r=>{
    const sub=!!r.dataset.plan&&(wantsSubscription||required),card=r.closest('.cg-bundle-card');
    card.querySelector('[data-offer-price]').textContent=sub?r.dataset.subPrice:r.dataset.price;
    const compare=card.querySelector('[data-offer-compare]');
    compare.textContent=sub?r.dataset.subCompare:r.dataset.compare;compare.hidden=!compare.textContent;
   });
  };
  radios.forEach(r=>r.addEventListener('change',sync));
  toggle.addEventListener('change',()=>{wantsSubscription=toggle.checked;sync();});
  form.addEventListener('submit',e=>{sync();if(button.disabled)e.preventDefault();});
  sync();
 });
}
initCollagenOffers(document);
document.addEventListener('shopify:section:load',()=>initCollagenOffers(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-cart-drawer"]) return;
  try {
    
(() => {
  const drawers = document.querySelectorAll('[data-lf-cart-drawer]');
  if (!drawers.length) return;
  const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[character]));
  const parseMoneyFormat = (cents, format) => {
    const amount = Number(cents || 0) / 100;
    const token = String(format || '$' + String.fromCharCode(123,123) + 'amount' + String.fromCharCode(125,125));
    const match = token.match(/\{\{\s*(amount(?:_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?)\s*\}\}/);
    if (!match) return new Intl.NumberFormat(undefined, {style:'currency', currency:window.Shopify?.currency?.active || 'USD'}).format(amount);
    let value;
    if (match[1] === 'amount_no_decimals') value = Math.round(amount).toLocaleString('en-US');
    else if (match[1] === 'amount_with_comma_separator') value = amount.toFixed(2).replace('.', ',');
    else if (match[1] === 'amount_no_decimals_with_comma_separator') value = Math.round(amount).toLocaleString('de-DE');
    else value = amount.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2});
    return token.replace(match[0], value);
  };
  drawers.forEach(drawer => {
    if (drawer.dataset.ready) return;
    drawer.dataset.ready = 'true';
    const config = JSON.parse(drawer.querySelector('[data-lf-cart-config]').textContent);
    const panel = drawer.querySelector('.lf-cart-panel');
    const loading = drawer.querySelector('[data-lf-cart-loading]');
    const empty = drawer.querySelector('[data-lf-cart-empty]');
    const itemsNode = drawer.querySelector('[data-lf-cart-items]');
    const footer = drawer.querySelector('[data-lf-cart-footer]');
    const protection = drawer.querySelector('[data-lf-protection]');
    const protectionToggle = drawer.querySelector('[data-lf-protection-toggle]');
    let previousFocus = null;
    let cartState = null;
    let busy = false;
    let timerInterval = null;
    const comparePriceByVariant = new Map();
    const formatMoney = cents => parseMoneyFormat(cents, config.moneyFormat);
    const protectionItem = cart => cart.items.find(item => String(item.handle) === String(config.protectionHandle) || Number(item.variant_id) === Number(config.protectionVariantId));
    const merchandiseItems = cart => cart.items.filter(item => item !== protectionItem(cart));
    const request = async (url, options = {}) => {
      const response = await fetch(url, {headers:{Accept:'application/json', ...(options.headers || {})}, ...options});
      if (!response.ok) throw new Error(config.errorText);
      return response.json();
    };
    const announceError = error => {
      loading.innerHTML = `<b aria-hidden="true">!</b>${escapeHtml(error.message || config.errorText)}`;
      loading.hidden = false;
      setTimeout(() => {loading.hidden = true;}, 3500);
    };
    const changeLine = async (key, quantity) => {
      if (busy) return;
      busy = true;
      try {cartState = await request(config.changeUrl + '.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:key, quantity})});await prepareAndRender(cartState);}
      catch (error) {announceError(error);} finally {busy = false;}
    };
    const addProtection = async () => {
      if (!config.protectionVariantId || busy) return;
      busy = true;
      try {const body = new FormData();body.append('id', String(config.protectionVariantId));body.append('quantity','1');await request(config.addUrl + '.js', {method:'POST', body});cartState = await request(config.cartUrl + '.js');await prepareAndRender(cartState);}
      catch (error) {announceError(error);} finally {busy = false;}
    };
    const removeProtection = async () => {
      const item = cartState && protectionItem(cartState);
      if (item) await changeLine(item.key, 0);
    };
    const loadComparePrices = async cart => {
      const missingItems = merchandiseItems(cart).filter(item => !comparePriceByVariant.has(Number(item.variant_id)));
      const handles = [...new Set(missingItems.map(item => item.handle).filter(Boolean))];
      await Promise.all(handles.map(async handle => {
        try {
          const product = await request(`${config.rootUrl}products/${encodeURIComponent(handle)}.js`);
          (product.variants || []).forEach(variant => comparePriceByVariant.set(Number(variant.id), Number(variant.compare_at_price || 0)));
        } catch (error) {
          missingItems.filter(item => item.handle === handle).forEach(item => comparePriceByVariant.set(Number(item.variant_id), 0));
        }
      }));
    };
    const syncProtectionDefault = async cart => {
      if (!protection || !config.protectionVariantId) return;
      const hasMerchandise = merchandiseItems(cart).length > 0;
      const hasProtection = Boolean(protectionItem(cart));
      const optedOut = sessionStorage.getItem('lf-protection-off') === 'true';
      if (!hasMerchandise && hasProtection) await removeProtection();
      else if (hasMerchandise && !hasProtection && config.protectionDefaultOn && !optedOut) await addProtection();
    };
    const itemMarkup = item => {
      const option = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="lf-cart-item-option">${escapeHtml(item.variant_title)}</p>` : '';
      const image = item.featured_image?.url || item.image;
      const imageMarkup = image ? `<img src="${escapeHtml(image)}&width=180" alt="${escapeHtml(item.featured_image?.alt || item.product_title)}" width="90" height="90" loading="eager">` : '';
      const compareAtTotal = Number(comparePriceByVariant.get(Number(item.variant_id)) || 0) * Number(item.quantity || 0);
      const referenceTotal = Math.max(Number(item.original_line_price || 0), compareAtTotal);
      const savedTotal = Math.max(0, referenceTotal - Number(item.final_line_price || 0));
      const compare = savedTotal > 0 ? `<s>${formatMoney(referenceTotal)}</s>` : '';
      const saved = savedTotal > 0 ? `<small>(${escapeHtml(config.youSaveLabel)} ${formatMoney(savedTotal)})</small>` : '';
      return `<li class="lf-cart-item" data-key="${escapeHtml(item.key)}"><a class="lf-cart-item-media" href="${escapeHtml(item.url)}">${imageMarkup}</a><div class="lf-cart-item-copy"><a class="lf-cart-item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>${option}<div class="lf-cart-quantity"><button type="button" data-lf-qty="${item.quantity - 1}" aria-label="${escapeHtml(config.decreaseLabel)}">−</button><span>${item.quantity}</span><button type="button" data-lf-qty="${item.quantity + 1}" aria-label="${escapeHtml(config.increaseLabel)}">+</button></div></div><div class="lf-cart-item-price"><div class="lf-cart-item-price-row">${compare}<span>${formatMoney(item.final_line_price)}</span></div>${saved}</div><button class="lf-cart-remove" type="button" data-lf-remove aria-label="${escapeHtml(config.removeLabel)}">×</button></li>`;
    };
    const render = cart => {
      cartState = cart;
      const regularItems = merchandiseItems(cart);
      const protectionLine = protectionItem(cart);
      const displayedCount = regularItems.reduce((sum, item) => sum + item.quantity, 0);
      drawer.querySelector('[data-lf-cart-title-count]').textContent = `${displayedCount} ${displayedCount === 1 ? config.itemLabel : config.itemsLabel}`;
      document.querySelectorAll('.lf-header-actions a[href$="/cart"]').forEach(link => {
        let node = link.querySelector('.lf-cart-count');
        if (!node && displayedCount > 0) {node = document.createElement('span');node.className = 'lf-cart-count';link.appendChild(node);}
        if (node) {node.textContent = displayedCount;node.classList.toggle('lf-cart-count--empty', displayedCount === 0);}
      });
      itemsNode.innerHTML = regularItems.map(itemMarkup).join('');
      empty.hidden = displayedCount > 0;
      footer.hidden = displayedCount === 0;
      drawer.querySelector('[data-lf-cart-progress-wrap]').hidden = !config.showFreeShipping || displayedCount === 0;
      if (protectionToggle) protectionToggle.setAttribute('aria-checked', String(Boolean(protectionLine)));
      const threshold = Number(config.freeShippingThreshold || 0);
      const merchandiseSubtotal = regularItems.reduce((sum, item) => sum + Number(item.final_line_price), 0);
      const remaining = Math.max(0, threshold - merchandiseSubtotal);
      drawer.querySelector('[data-lf-cart-progress]').style.width = `${threshold > 0 ? Math.min(100, merchandiseSubtotal / threshold * 100) : 100}%`;
      drawer.querySelector('[data-lf-cart-progress-text]').textContent = remaining > 0 ? `${config.freeShippingBefore} ${formatMoney(remaining)} ${config.freeShippingAfter}` : config.freeShippingReached;
      const savings = Number(cart.original_total_price || cart.total_price) - Number(cart.total_price);
      drawer.querySelector('[data-lf-savings-row]').hidden = savings <= 0;
      drawer.querySelector('[data-lf-savings]').textContent = '−' + formatMoney(Math.max(0, savings));
      drawer.querySelector('[data-lf-cart-total]').textContent = formatMoney(cart.total_price);
      loading.hidden = true;
    };
    const prepareAndRender = async cart => {await loadComparePrices(cart);render(cart);};
    const load = async applyDefault => {
      loading.hidden = false;
      try {const cart = await request(config.cartUrl + '.js');await prepareAndRender(cart);if (applyDefault) await syncProtectionDefault(cart);}
      catch (error) {announceError(error);}
    };
    const startTimer = () => {
      const node = drawer.querySelector('[data-lf-cart-timer]');
      if (!node) return;
      const storageKey = 'lf-cart-reserved-until';
      let end = Number(sessionStorage.getItem(storageKey));
      if (!end || end <= Date.now()) {end = Date.now() + Number(config.timerMinutes || 5) * 60000;sessionStorage.setItem(storageKey, String(end));}
      clearInterval(timerInterval);
      const tick = () => {const seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));node.textContent = `${String(Math.floor(seconds / 60)).padStart(2,'0')}:${String(seconds % 60).padStart(2,'0')}`;if (!seconds) clearInterval(timerInterval);};
      tick();timerInterval = setInterval(tick, 1000);
    };
    const open = event => {
      event?.preventDefault();previousFocus = document.activeElement;drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.classList.add('lf-cart-locked');panel.focus({preventScroll:true});startTimer();load(true);
    };
    const close = () => {drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.body.classList.remove('lf-cart-locked');clearInterval(timerInterval);previousFocus?.focus?.();};
    document.addEventListener('click', event => {const opener = event.target.closest('[data-lf-cart-open],.lf-header-actions a[href$="/cart"]');if (opener) open(event);});
    drawer.querySelectorAll('[data-lf-cart-close]').forEach(button => button.addEventListener('click', close));
    drawer.addEventListener('click', event => {const item = event.target.closest('[data-key]');if (!item) return;if (event.target.closest('[data-lf-remove]')) changeLine(item.dataset.key, 0);const quantityButton = event.target.closest('[data-lf-qty]');if (quantityButton) changeLine(item.dataset.key, Number(quantityButton.dataset.lfQty));});
    protectionToggle?.addEventListener('click', async () => {const active = protectionToggle.getAttribute('aria-checked') === 'true';protectionToggle.setAttribute('aria-checked', String(!active));if (active) {sessionStorage.setItem('lf-protection-off','true');await removeProtection();} else {sessionStorage.removeItem('lf-protection-off');await addProtection();}});
    document.addEventListener('keydown', event => {if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();});
    document.addEventListener('submit', async event => {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (!form || form.closest('[data-lf-cart-drawer]')) return;
      event.preventDefault();
      const submit = event.submitter;if (submit) submit.disabled = true;
      try {await request(config.addUrl + '.js', {method:'POST', body:new FormData(form)});open();}
      catch (error) {announceError(error);open();}
      finally {if (submit) submit.disabled = false;}
    });
    load(false);
    const cartPath = String(location.pathname || '').replace(/\/$/, '');
    if (cartPath.endsWith('/cart')) requestAnimationFrame(() => open());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-header"]) return;
  try {
    
if (!customElements.get('leefar-navigation')) {
  customElements.define('leefar-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      const toggle = this.querySelector('.lf-nav-toggle');
      const restore = () => {
        if (this.locked) { document.body.style.overflow = this.previousOverflow; this.locked = false; }
        toggle.setAttribute('aria-expanded', 'false');
      };
      this.restore = restore;
      toggle.addEventListener('click', () => {
        this.previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        this.locked = true;
        toggle.setAttribute('aria-expanded', 'true');
      }, options);
      this.querySelector('.lf-nav-close').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('close', restore, options);
      dialog.addEventListener('click', event => {
        if (event.target.closest('a')) dialog.close();
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }, options);
    }
    disconnectedCallback() { if (this.restore) this.restore(); if (this.controller) this.controller.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-home-hero"] && !Shopify.designMode) return;
  try {
    

(() => {

  const reveal = () => {

    const items =
      document.querySelectorAll('.lfh-reveal:not([data-lfh-ready])');

    if (!items.length) return;

    if (
      matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {

      items.forEach((item) => {
        item.dataset.lfhReady = '1';
        item.classList.add('is-visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }

        });

      },
      {
        threshold: .14,
        rootMargin: '0px 0px -25px'
      }
    );

    items.forEach((item, index) => {

      item.dataset.lfhReady = '1';

      item.style.transitionDelay =
        `${Math.min(index % 4, 3) * 80}ms`;

      observer.observe(item);

    });

  };

  reveal();

  document.addEventListener(
    'shopify:section:load',
    reveal
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-melatonin-offer"] && !Shopify.designMode) return;
  try {
    


document.addEventListener('change',event=>{const radio=event.target.closest('.lf-bundles input');if(radio){radio.form.querySelector('[name="quantity"]').value=radio.value;}const quantity=event.target.closest('.lf-melatonin [name="quantity"]');if(quantity){const tier=Number(quantity.value);const option=quantity.form.querySelector('[name="bundle_quantity"][value="'+tier+'"]');if(option)option.checked=true;}});

document.addEventListener('click',event=>{const link=event.target.closest('.lf-melatonin__thumbs a');if(!link)return;const target=document.getElementById(link.hash.slice(1));if(!target)return;event.preventDefault();const slides=target.parentElement;slides.scrollTo({left:target.offsetLeft-slides.firstElementChild.offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});});
document.addEventListener('change',event=>{const select=event.target.closest('.lf-melatonin select[name=id]');if(!select)return;const root=select.closest('.lf-melatonin');const option=select.selectedOptions[0];root.querySelector('[data-melatonin-price]').textContent=option.dataset.price;const stickyPrice=root.querySelector('[data-melatonin-sticky-price]');if(stickyPrice)stickyPrice.textContent=option.dataset.price;const compare=root.querySelector('[data-melatonin-compare]');compare.textContent=option.dataset.compare;compare.hidden=option.dataset.onSale!=='true';const badge=root.querySelector('[data-melatonin-saving]');if(badge)badge.hidden=true;const add=root.querySelector('[name=add]');add.disabled=option.dataset.available!=='true';add.textContent=add.disabled?add.dataset.soldLabel:add.dataset.addLabel;const stickyAdd=root.querySelector('.lf-melatonin__sticky-add');if(stickyAdd){stickyAdd.disabled=add.disabled;stickyAdd.setAttribute('aria-label',add.textContent);stickyAdd.innerHTML=add.disabled?'<span>Sold out</span>':'<svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5h2l2 10h11l2-7H6"/><circle cx="9" cy="19" r="1"/><circle cx="17" cy="19" r="1"/><path d="M17 2v6m-3-3h6"/></svg>';}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-melatonin-product"] && !Shopify.designMode) return;
  try {
    


document.addEventListener('change',event=>{const radio=event.target.closest('.lf-bundles input');if(radio){radio.form.querySelector('[name="quantity"]').value=radio.value;}const quantity=event.target.closest('.lf-melatonin [name="quantity"]');if(quantity){const tier=Math.min(3,Math.max(1,Number(quantity.value)));const option=quantity.form.querySelector('[name="bundle_quantity"][value="'+tier+'"]');if(option)option.checked=true;}});

document.addEventListener('click',event=>{const link=event.target.closest('.lf-melatonin__thumbs a');if(!link)return;const target=document.getElementById(link.hash.slice(1));if(!target)return;event.preventDefault();const slides=target.parentElement;slides.scrollTo({left:target.offsetLeft-slides.firstElementChild.offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});});
document.addEventListener('change',event=>{const select=event.target.closest('.lf-melatonin select[name=id]');if(!select)return;const root=select.closest('.lf-melatonin');const option=select.selectedOptions[0];root.querySelector('[data-melatonin-price]').textContent=option.dataset.price;const stickyPrice=root.querySelector('[data-melatonin-sticky-price]');if(stickyPrice)stickyPrice.textContent=option.dataset.price;const compare=root.querySelector('[data-melatonin-compare]');compare.textContent=option.dataset.compare;compare.hidden=option.dataset.onSale!=='true';const badge=root.querySelector('[data-melatonin-saving]');if(badge)badge.hidden=true;const add=root.querySelector('[name=add]');add.disabled=option.dataset.available!=='true';add.textContent=add.disabled?add.dataset.soldLabel:add.dataset.addLabel;const stickyAdd=root.querySelector('.lf-melatonin__sticky-add');if(stickyAdd){stickyAdd.disabled=add.disabled;stickyAdd.setAttribute('aria-label',add.textContent);stickyAdd.innerHTML=add.disabled?'<span>Sold out</span>':'<svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5h2l2 10h11l2-7H6"/><circle cx="9" cy="19" r="1"/><circle cx="17" cy="19" r="1"/><path d="M17 2v6m-3-3h6"/></svg>';}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-reviews"] && !Shopify.designMode) return;
  try {
    

(() => {

  const carousels = document.querySelectorAll(
    '[data-carousel]'
  );

  carousels.forEach((carousel) => {

    if (carousel.dataset.lfCarouselReady) return;

    carousel.dataset.lfCarouselReady = 'true';

    const track =
      carousel.querySelector('[data-track]');

    const prev =
      carousel.querySelector('[data-prev]');

    const next =
      carousel.querySelector('[data-next]');

    if (!track) return;


    const getScrollAmount = () => {

      const card =
        track.querySelector('article');

      if (!card) {
        return track.clientWidth;
      }

      const styles =
        getComputedStyle(track);

      const gap =
        parseFloat(styles.gap) || 0;

      return card.offsetWidth + gap;

    };


    prev?.addEventListener('click', () => {

      track.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });

    });


    next?.addEventListener('click', () => {

      track.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });

    });

  });

})();


  } catch(e) { console.error(e); }
})();
})();
